import { render, staticRenderFns } from "./detalles_portico.vue?vue&type=template&id=722ab58c&scoped=true&"
import script from "./detalles_portico.vue?vue&type=script&lang=js&"
export * from "./detalles_portico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ab58c",
  null
  
)

export default component.exports